import { Helmet } from "react-helmet-async";

/**
 * Default <title> for loading/skeleton states.
 *
 * The root route deliberately ships no <title> (a root-level title produced a
 * second <title> tag on every page). Loading branches render this so the
 * server HTML always contains exactly one title.
 */
const FallbackTitle = ({
  title = "Garden-Review | UK Garden Tool Reviews & Advice",
  description = "Independent UK reviews of garden tools and machinery, plus practical growing advice from the Garden-Review team.",
}: {
  title?: string;
  description?: string;
}) => (
  <Helmet>
    <title>{title}</title>
    <meta name="description" content={description} />
  </Helmet>
);

export default FallbackTitle;
